import Section from '../../../elements/Section'
import styles from './styles.module.scss'
import Container from '../../../elements/Container'
import Button from '../../../elements/Button'
import IconMore from '/public/icons/icon-more.svg'
import { useState } from 'react'
import AccordionGroup from '../../../elements/AccordionGroup'

const FAQs = ({ label, title, faqs, button }) => {
  const [number, setNumber] = useState(5)

  if (faqs) {
    return (
      <Section variant={['gray', 'center']}>
        <Container variant={['-xs3']}>
          {label && <div className={styles.label}>{label}</div>}
          {title && <h2 className={styles.title}>{title}</h2>}

          <AccordionGroup items={faqs} max={number} />

          {number < faqs && (
            <Button
              appendIcon={<IconMore />}
              variant={['color-primary']}
              arrow={false}
              className={styles.button}
              onClick={() => setNumber(number + 5)}
            >
              {button}
            </Button>
          )}
        </Container>
      </Section>
    )
  }
  return
}
export default FAQs
